export let registeredEditCategoryTabs = [];

export function clearRegisteredEditCategoryTabs() {
  registeredEditCategoryTabs.length = 0;
}
